import React, { useEffect, useRef, useState } from 'react';
import { motion } from "framer-motion";
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { Editor } from '@tinymce/tinymce-react';
import api from '../utils/api';

function EditAnnouncements() {
  const editorRef = useRef(null);
  const { annoucementid } = useParams();
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('');
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      api
        .get(`/api/announcements/${annoucementid}`)
        .then((res) => {
          setTitle(res.data.title);
          setDescription(res.data.description);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Failed to fetch announcement detail:", err);
          setLoading(false);
        });
    }, [annoucementid]);

 const handlePublish = (confirmPub) => {
    
    let content = description;
    if (editorRef.current) {
      content = editorRef.current.getContent();
      setDescription(content);
    }

    if (!title.trim() || !content.trim()) {
      toast.warning("Please fill in both Title and Description.");
      return;
    }

    const payload = {
      title: title.trim(),
      description: content.trim(),
      isPublished: confirmPub // Assuming you want to publish immediately
    };

    api.put(`/api/announcements/${annoucementid}`, payload)
      .then(() => {
        toast.success("Announcement published successfully!");
        if(confirmPub){
            navigate('/hr/events/annoucements');
        }
        else{
            navigate('/hr/events/saved/annoucements');
        }
       
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to publish announcement.");
      });
  };

  return (
    <div className="sm:p-6 sm:mt-auto mt-8 am:mb-auto mb-20 w-full mx-auto">
      {/* Header */}
      <motion.div
        className="flex justify-between items-center mb-6"
        transition={{ duration: 0.4, type: "spring" }}
      >
        <h2 className="text-xl xs:text-2xl font-bold truncate">Edit Announcement</h2>

        <div className='flex items-center gap-4'>
                     
               <motion.button
                 onClick={()=>handlePublish(false)}
                 className="bg-red-800 text-white px-4 py-2 rounded-full hover:bg-red-700 flex items-center gap-2"
                 whileHover={{ scale: 1.02 }}
                 whileTap={{ scale: 0.98 }}
               >
                 <span>Save</span>
               </motion.button>
       
               <motion.button
                 onClick={()=>handlePublish(true)}
                 className="bg-slate-800 text-white px-4 py-2 rounded-full hover:bg-slate-700 flex items-center gap-2"
                 whileHover={{ scale: 1.02 }}
                 whileTap={{ scale: 0.98 }}
               >
                 <span>Publish</span>
               </motion.button>
               </div>
      </motion.div>

      {/* Form Card */}
      <div className='p-5 bg-white rounded-xl shadow-md'>
        {/* Title Input */}
        <div className="mb-4">
          <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1">
            Title
          </label>
          <input
            id="title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter announcement title"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Description Textarea */}
        <div className="mb-6">
          <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
            Description
          </label>
         

          <Editor
        apiKey="0gn9yss8ret4r57j1fv7mkpi82edq9ug8462u60sexpqh4nu"
        onInit={(evt, editor) => editorRef.current = editor}
        value={description}
        init={{
          height: 400,
          menubar: false,
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
            'preview', 'anchor', 'searchreplace', 'visualblocks',
            'code', 'fullscreen', 'insertdatetime', 'media', 'table', 'code'
          ],
          toolbar:
            'undo redo | formatselect | ' +
            'bold italic underline forecolor backcolor | blocks fontfamily fontsize | ' +
            'alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | table | removeformat',
          content_style: `
           body { font-family: Arial, Helvetica, sans-serif; }
            table, th, td {
              border: 1px solid rgb(0, 0, 0) !important;
              border-collapse: collapse !important;
            }
            th, td {
              padding: 8px !important;
            }
          `
        }}
      />
        </div>
      </div>
    </div>
  );
}

export default EditAnnouncements;
